import { render, staticRenderFns } from "./ManagePackageTitles.vue?vue&type=template&id=1ca1c358&"
import script from "./ManagePackageTitles.vue?vue&type=script&lang=js&"
export * from "./ManagePackageTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports